module.exports = __webpack_public_path__ + "img/ggl.0141b762.svg";